let uniqueInteger = 0;
function getUniqueInteger() {
  return ++uniqueInteger;
}

export {
    getUniqueInteger
}
